export const formConfig = {
  "access": {
    "hub": {
      "enabled": true,
      "path": "/hub",
      "accessKeyEnvVar": "VITE_HUB_ACCESS_KEY"
    },
    "publicShare": {
      "enabled": true,
      "queryParam": "k"
    }
  },
  "app": {
    "name": "BPA Forms Hub",
    "description": "A premium, configurable multi-form intake hub for BPA Solutions.",
    "version": "1.0.0",
    "branding": {
      "logo": "https://i.ibb.co/QjnJygFC/logo.webp",
      "primaryColorRef": "primary",
      "accentColorRef": "accent"
    },
    "layout": {
      "sidebar": {
        "enabled": true,
        "position": "left",
        "width": "280px"
      },
      "header": {
        "enabled": true,
        "showLogo": true,
        "showAppName": true
      }
    },
    "defaultTheme": "light"
  },
  "themes": {
    "themes": [
      {
        "id": "light",
        "label": "Light",
        "isDark": false,
        "colors": {
          "background": "#ffffff",
          "surface": "#f8fafc",
          "surfaceAlt": "#f1f5f9",
          "primary": "#1d4ed8",
          "primarySoft": "#dbeafe",
          "primaryStrong": "#1e40af",
          "accent": "#0ea5e9",
          "accentSoft": "#e0f2fe",
          "accentStrong": "#0369a1",
          "border": "#e2e8f0",
          "text": "#0f172a",
          "textMuted": "#475569",
          "success": "#16a34a",
          "warning": "#f59e0b",
          "danger": "#dc2626"
        },
        "components": {
          "button": {
            "borderRadius": "12px",
            "paddingX": "16px",
            "paddingY": "12px",
            "fontWeight": "700"
          },
          "input": {
            "borderRadius": "12px",
            "paddingX": "14px",
            "paddingY": "12px",
            "borderColor": "#e2e8f0",
            "focusBorderColor": "#1d4ed8"
          },
          "card": {
            "borderRadius": "16px",
            "padding": "24px",
            "elevation": "sm"
          }
        }
      },
      {
        "id": "dark",
        "label": "Dark",
        "isDark": true,
        "colors": {
          "background": "#0b1220",
          "surface": "#0f172a",
          "surfaceAlt": "#111c33",
          "primary": "#60a5fa",
          "primarySoft": "#172554",
          "primaryStrong": "#93c5fd",
          "accent": "#22d3ee",
          "accentSoft": "#164e63",
          "accentStrong": "#67e8f9",
          "border": "#23314f",
          "text": "#e5e7eb",
          "textMuted": "#9ca3af",
          "success": "#22c55e",
          "warning": "#fbbf24",
          "danger": "#f87171"
        },
        "components": {
          "button": {
            "borderRadius": "12px",
            "paddingX": "16px",
            "paddingY": "12px",
            "fontWeight": "700"
          },
          "input": {
            "borderRadius": "12px",
            "paddingX": "14px",
            "paddingY": "12px",
            "borderColor": "#23314f",
            "focusBorderColor": "#60a5fa"
          },
          "card": {
            "borderRadius": "16px",
            "padding": "24px",
            "elevation": "sm"
          }
        }
      }
    ],
    "themeSwitcher": {
      "enabled": true,
      "position": "header-right"
    }
  },
  "navigation": {
    "primary": {
      "items": [
        { "id": "navWebsiteIntake", "label": "Website Client Intake", "icon": "Clipboard", "type": "form", "targetId": "websiteClientIntake" },
        { "id": "navAdsIntake", "label": "Ads Intake", "icon": "Target", "type": "form", "targetId": "adsIntake" },
        { "id": "navUpdateRequest", "label": "Update Request", "icon": "Edit3", "type": "form", "targetId": "updateRequest" }
      ]
    },
    "secondary": {
      "items": [
        { "id": "navResearchNotes", "label": "Research Notes", "icon": "FileText", "type": "page", "targetId": "researchNotes" }
      ]
    },
    "footer": {
      "items": [
        { "id": "navPrivacy", "label": "Privacy Policy", "icon": "Shield", "type": "page", "targetId": "privacyPolicy" },
        { "id": "navTerms", "label": "Terms", "icon": "File", "type": "page", "targetId": "terms" }
      ]
    }
  },
  "site": {
    "baseUrl": "https://forms.bpasolutions.au",
    "publicBaseUrl": "https://forms.bpasolutions.au",
    "pages": [
      {
        "id": "researchNotes",
        "title": "Research Notes",
        "blocks": [
          { "type": "paragraph", "text": "Internal knowledge management for BPA Forms Hub." }
        ]
      },
      {
        "id": "privacyPolicy",
        "title": "Privacy Policy",
        "blocks": [{ "type": "paragraph", "text": "Placeholder privacy policy." }]
      },
      {
        "id": "terms",
        "title": "Terms",
        "blocks": [{ "type": "paragraph", "text": "Placeholder terms." }]
      }
    ],
    "routes": [
      {
        "id": "routeWebsiteClientIntake",
        "path": "/website-intake",
        "sharePath": "/f/website-intake",
        "shareKey": "WINTAKE-2026",
        "label": "Website Client Intake",
        "description": "Full intake form for premium website projects.",
        "type": "form",
        "targetId": "websiteClientIntake",
        "icon": "Clipboard",
        "visibleInNav": true
      },
      {
        "id": "routeAdsIntake",
        "path": "/ads-intake",
        "sharePath": "/f/ads-intake",
        "shareKey": "ADS-2026",
        "label": "Ads Intake",
        "description": "Initial intake for paid media campaigns.",
        "type": "form",
        "targetId": "adsIntake",
        "icon": "Target",
        "visibleInNav": true
      },
      {
        "id": "routeUpdateRequest",
        "path": "/update-request",
        "sharePath": "/f/update-request",
        "shareKey": "UPDATE-2026",
        "label": "Update Request",
        "description": "Submit a change request for an existing site.",
        "type": "form",
        "targetId": "updateRequest",
        "icon": "Edit3",
        "visibleInNav": true
      }
    ]
  },
  "forms": [
    {
      "id": "websiteClientIntake",
      "name": "Website Client Intake",
      "description": "A premium end-to-end intake for high-end website projects.",
      "category": "Client Onboarding",
      "icon": "Clipboard",
      "layout": { "columns": 1, "showSectionProgress": true, "showOverallProgress": true, "progressStyle": "steps" },
      "submission": {
        "successMessage": "Thank you. Your website intake has been submitted successfully. Our team will review it shortly.",
        "failureMessage": "Submission failed. Please check the form and try again.",
        "redirectUrl": null,
        "storeSubmission": true
      },
      "fields": [
        { "id": "clientName", "type": "text", "label": "Client name", "placeholder": "Full name", "required": true },
        { "id": "clientEmail", "type": "email", "label": "Email", "placeholder": "name@business.com", "required": true },
        { "id": "clientPhone", "type": "tel", "label": "Phone number", "placeholder": "Mobile", "required": true },
        { "id": "businessName", "type": "text", "label": "Company name", "placeholder": "Business name", "required": true },
        { "id": "industry", "type": "text", "label": "Industry", "placeholder": "e.g. Legal, NDIS", "required": true },
        { "id": "businessOverview", "type": "textarea", "label": "Business overview", "placeholder": "Describe what you do", "required": true },
        { "id": "primaryGoal", "type": "select", "label": "Primary project goal", "required": true, "options": [
          { "value": "lead-gen", "label": "Generate more enquiries" },
          { "value": "credibility", "label": "Improve trust" },
          { "value": "sales", "label": "Sell products" }
        ]},
        { "id": "budgetRange", "type": "select", "label": "Project budget", "required": true, "options": [
          { "value": "2k-5k", "label": "$2k to $5k" },
          { "value": "5k-10k", "label": "$5k to $10k" },
          { "value": "10k-plus", "label": "$10k+" }
        ]},
        { "id": "consentAcknowledgement", "type": "checkbox", "label": "I acknowledge the Privacy Policy and confirm information is accurate", "required": true }
      ],
      "sections": [
        { "id": "clientDetails", "title": "Client details", "fieldIds": ["clientName", "clientEmail", "clientPhone", "businessName", "industry"] },
        { "id": "projectOverview", "title": "Project overview", "fieldIds": ["businessOverview", "primaryGoal", "budgetRange"] },
        { "id": "consent", "title": "Consent", "fieldIds": ["consentAcknowledgement"] }
      ]
    }
  ],
  "email": {
    "provider": {
      "name": "emailit",
      "proxyEndpoint": "/api/send-email",
      "replyToStrategy": {
        "useClientEmailIfAvailable": true,
        "fallbackAddress": "support@bpasolutions.au"
      }
    },
    "routes": [
      {
        "id": "emailWebsiteIntake",
        "formId": "websiteClientIntake",
        "recipients": { "to": [{ "type": "field", "value": "clientEmail" }] },
        "templates": {
          "clientConfirmation": {
            "enabled": true,
            "subject": "We received your {{form.name}} submission ({{submissionId}})",
            "bodyText": "Hi {{submission.clientName}},\n\nThank you for submitting the {{form.name}}.\nSubmission ID: {{submissionId}}\n\n{{app.name}}",
            "bodyHtml": "<p>Hi <strong>{{submission.clientName}}</strong>,</p><p>Thank you for submitting the <strong>{{form.name}}</strong>.</p><p><strong>Submission ID:</strong> {{submissionId}}</p><p>{{app.name}}</p>"
          },
          "internalNotification": {
            "enabled": true,
            "subject": "New submission: {{form.name}} ({{submissionId}})",
            "bodyText": "New submission received.\nForm: {{form.name}}\nClient: {{submission.clientName}}\nEmail: {{submission.clientEmail}}",
            "bodyHtml": "<h3>New submission received</h3><ul><li><strong>Form:</strong> {{form.name}}</li><li><strong>Client:</strong> {{submission.clientName}}</li><li><strong>Email:</strong> {{submission.clientEmail}}</li></ul>"
          }
        }
      }
    ]
  }
};